"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exchangeReducerFunction = exports.exchangeAction = exports.ExchangeState = exports.initialState = void 0;
var immer_reducer_1 = require("immer-reducer");
exports.initialState = {
    appointments: {
        appointmentsList: null,
        errorMessage: null,
        loading: false
    },
    formData: {
        selectedAppointment: null,
        interventionType: null,
        informationData: null
    },
    bookingStatus: {
        errorMessage: null,
        loading: false,
        status: null
    },
    cancelAppointmentStatus: {
        errorMessage: null,
        loading: false,
        status: null
    },
    clientRequests: {
        clientRequestsList: null,
        loading: false,
        errorMessage: null,
        success: null
    },
    clientRequestsEligibility: {
        clientRequestsEligibility: null,
        loading: false,
        errorMessage: null,
        success: null
    },
    alertsMultiRecipients: {
        alertsMultiRecipients: null,
        loading: false,
        errorMessage: null,
        success: null
    },
    updateRecipientStatus: {
        errorMessage: null,
        loading: false,
        status: null,
        alertContacts: null
    },
    validateAlertContactStatus: {
        errorMessage: null,
        errorCode: null,
        loading: false,
        status: null
    }
};
var ExchangeState = /** @class */ (function (_super) {
    __extends(ExchangeState, _super);
    function ExchangeState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExchangeState.prototype.setInterventionData = function (InterData) {
        this.draftState.formData.interventionType = InterData;
    };
    ExchangeState.prototype.setInformationData = function (informationData) {
        this.draftState.formData.informationData = informationData;
    };
    ExchangeState.prototype.getAppointments = function (workExecutionId) {
        this.draftState.appointments.loading = true;
    };
    ExchangeState.prototype.getAppointmentsFailure = function (errorMessage) {
        this.draftState.appointments.loading = false;
        this.draftState.appointments.errorMessage = errorMessage;
    };
    ExchangeState.prototype.getAppointmentsSuccess = function (appointments) {
        this.draftState.appointments.loading = false;
        this.draftState.appointments.appointmentsList = appointments;
        this.draftState.appointments.errorMessage = null;
    };
    ExchangeState.prototype.setSelectedAppointment = function (appointment) {
        this.draftState.formData.selectedAppointment = appointment;
    };
    // handle booking saving process
    // sectionsubscriptionid: string, mode: "create" | "edit" = "create"
    ExchangeState.prototype.bookAppointment = function (data) {
        this.draftState.bookingStatus.loading = true;
        this.draftState.bookingStatus.errorMessage = null;
        this.draftState.bookingStatus.status = null;
    };
    ExchangeState.prototype.bookAppointmentSuccess = function (status) {
        this.draftState.bookingStatus.loading = false;
        this.draftState.bookingStatus.errorMessage = null;
        this.draftState.bookingStatus.status = status;
    };
    ExchangeState.prototype.bookAppointmentFailure = function (status, errorMessage) {
        this.draftState.bookingStatus.loading = false;
        this.draftState.bookingStatus.errorMessage = errorMessage;
        this.draftState.bookingStatus.status = status;
    };
    ExchangeState.prototype.resetBookingState = function () {
        this.draftState.bookingStatus = __assign({}, exports.initialState.bookingStatus);
    };
    // handle appointement cancellation
    ExchangeState.prototype.cancelAppointment = function (workExecutionId) {
        this.draftState.cancelAppointmentStatus.loading = true;
        this.draftState.cancelAppointmentStatus.errorMessage = null;
        this.draftState.cancelAppointmentStatus.status = null;
    };
    ExchangeState.prototype.cancelAppointmentSuccess = function (status) {
        this.draftState.cancelAppointmentStatus.loading = false;
        this.draftState.cancelAppointmentStatus.errorMessage = null;
        this.draftState.cancelAppointmentStatus.status = status;
    };
    ExchangeState.prototype.cancelAppointmentFailure = function (status, errorMessage) {
        this.draftState.cancelAppointmentStatus.loading = false;
        this.draftState.cancelAppointmentStatus.errorMessage = errorMessage;
        this.draftState.cancelAppointmentStatus.status = status;
    };
    ExchangeState.prototype.resetCancelAppointementState = function () {
        this.draftState.cancelAppointmentStatus = __assign({}, exports.initialState.cancelAppointmentStatus);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ExchangeState.prototype.getClientRequests = function (clientId) {
        this.draftState.clientRequests.loading = true;
        this.draftState.clientRequests.errorMessage = null;
        this.draftState.clientRequests.success = false;
        this.draftState.clientRequests.clientRequestsList = null;
    };
    ExchangeState.prototype.getClientRequestsSuccess = function (clientRequestsList) {
        this.draftState.clientRequests.loading = false;
        this.draftState.clientRequests.errorMessage = null;
        this.draftState.clientRequests.success = true;
        this.draftState.clientRequests.clientRequestsList = clientRequestsList;
    };
    ExchangeState.prototype.getClientRequestsFailure = function (errorMessage) {
        this.draftState.clientRequests.loading = false;
        this.draftState.clientRequests.errorMessage = errorMessage;
        this.draftState.clientRequests.success = false;
        this.draftState.clientRequests.clientRequestsList = null;
    };
    ExchangeState.prototype.getClientRequestsEligibility = function (clientId) {
        this.draftState.clientRequestsEligibility.loading = true;
        this.draftState.clientRequestsEligibility.errorMessage = null;
        this.draftState.clientRequestsEligibility.success = false;
        this.draftState.clientRequestsEligibility.clientRequestsEligibility = null;
    };
    ExchangeState.prototype.getClientRequestsEligibilitySuccess = function (clientRequestsEligibility) {
        this.draftState.clientRequestsEligibility.loading = false;
        this.draftState.clientRequestsEligibility.errorMessage = null;
        this.draftState.clientRequestsEligibility.success = true;
        this.draftState.clientRequestsEligibility.clientRequestsEligibility = clientRequestsEligibility;
    };
    ExchangeState.prototype.getClientRequestsEligibilityFailure = function (errorMessage) {
        this.draftState.clientRequestsEligibility.loading = false;
        this.draftState.clientRequestsEligibility.errorMessage = errorMessage;
        this.draftState.clientRequestsEligibility.success = false;
        this.draftState.clientRequestsEligibility.clientRequestsEligibility = null;
    };
    ExchangeState.prototype.getAlertsMultiRecipients = function (clientId) {
        this.draftState.alertsMultiRecipients.loading = true;
        this.draftState.alertsMultiRecipients.errorMessage = null;
        this.draftState.alertsMultiRecipients.success = false;
        this.draftState.alertsMultiRecipients.alertsMultiRecipients = null;
    };
    ExchangeState.prototype.getAlertsMultiRecipientsSuccess = function (alertsMultiRecipients) {
        this.draftState.alertsMultiRecipients.loading = false;
        this.draftState.alertsMultiRecipients.errorMessage = null;
        this.draftState.alertsMultiRecipients.success = true;
        this.draftState.alertsMultiRecipients.alertsMultiRecipients = alertsMultiRecipients;
    };
    ExchangeState.prototype.getAlertsMultiRecipientsFailure = function (errorMessage) {
        this.draftState.alertsMultiRecipients.loading = false;
        this.draftState.alertsMultiRecipients.errorMessage = errorMessage;
        this.draftState.alertsMultiRecipients.success = false;
        this.draftState.alertsMultiRecipients.alertsMultiRecipients = null;
    };
    ExchangeState.prototype.updateRecipientsAlert = function (data) {
        this.draftState.updateRecipientStatus.loading = true;
        this.draftState.updateRecipientStatus.errorMessage = null;
        this.draftState.updateRecipientStatus.status = null;
        this.draftState.updateRecipientStatus.alertContacts = null;
    };
    ExchangeState.prototype.updateRecipientsAlertSuccess = function (status, alertContacts) {
        this.draftState.updateRecipientStatus.loading = false;
        this.draftState.updateRecipientStatus.errorMessage = null;
        this.draftState.updateRecipientStatus.status = status;
        this.draftState.updateRecipientStatus.alertContacts = alertContacts;
    };
    ExchangeState.prototype.updateRecipientsAlertFailure = function (status, errorMessage) {
        this.draftState.updateRecipientStatus.loading = false;
        this.draftState.updateRecipientStatus.errorMessage = errorMessage;
        this.draftState.updateRecipientStatus.status = status;
        this.draftState.updateRecipientStatus.alertContacts = null;
    };
    ExchangeState.prototype.validateAlertContact = function (token) {
        this.draftState.validateAlertContactStatus.loading = true;
        this.draftState.validateAlertContactStatus.errorMessage = null;
        this.draftState.validateAlertContactStatus.errorCode = null;
        this.draftState.validateAlertContactStatus.status = null;
    };
    ExchangeState.prototype.validateAlertContactSuccess = function (status) {
        this.draftState.validateAlertContactStatus.loading = false;
        this.draftState.validateAlertContactStatus.errorMessage = null;
        this.draftState.validateAlertContactStatus.errorCode = null;
        this.draftState.validateAlertContactStatus.status = status;
    };
    ExchangeState.prototype.validateAlertContactFailure = function (status, errorMessage, errorCode) {
        this.draftState.validateAlertContactStatus.loading = false;
        this.draftState.validateAlertContactStatus.errorMessage = errorMessage;
        this.draftState.validateAlertContactStatus.errorCode = errorCode;
        this.draftState.validateAlertContactStatus.status = status;
    };
    ExchangeState.prototype.reset = function () {
        this.draftState = exports.initialState;
    };
    return ExchangeState;
}(immer_reducer_1.ImmerReducer));
exports.ExchangeState = ExchangeState;
exports.exchangeAction = (0, immer_reducer_1.createActionCreators)(ExchangeState);
exports.exchangeReducerFunction = (0, immer_reducer_1.createReducerFunction)(ExchangeState, exports.initialState);
